import React from 'react';
import { Layout } from 'antd';
import { BasicProps as HeaderProps } from 'antd/lib/layout/layout';

const { Header } = Layout;

export const LayoutHeader = React.memo<HeaderProps>((props) => {
  return <Header id='mainHeader' {...props} />;
});
